import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';

import { LoginComponent } from './login/login.component';
import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';
import { IconsComponent } from './icons/icons.component';
import { AcessoComponent } from './acesso/acesso.component';

@NgModule({
    imports: [
        SharedModule,
        // RouterModule.forChild(routes)
    ],
    declarations: [
        LoginComponent,
        RecuperarSenhaComponent,
        IconsComponent,
        AcessoComponent
    ],
    exports: [
        RouterModule,
        LoginComponent
    ]
})

export class PagesModule { }
